import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-block-base-component',
    template: '',
    standalone: false
})
export class BlockBaseComponent {
    @Input() readOnly: boolean;
    // @Output() submitted: EventEmitter<BlockBaseData> = new EventEmitter<BlockBaseData>();
    // @Output() totalChanged: EventEmitter<BlockBaseData> = new EventEmitter<BlockBaseData>();

    // public isSaving = false;

    public errorMsg: string;
    public errorMsgClass: string;

    constructor() { }

    public setErroMsg(errorMsg: string, sucess: boolean, systemError: boolean): void {
        if (!(sucess && this.errorMsgClass === 'alert-success')) {
            this.errorMsg = errorMsg;
        }
        if (sucess) {
            this.errorMsgClass = 'alert-success';
            setTimeout(() => {
                // console.log('errorMsg: => cleaning' + this.errorMsg);
                this.errorMsg = '';
                this.errorMsgClass = '';
            }, 4000);
        } else {
            this.errorMsgClass = 'alert-danger';
        }
        if (!this.errorMsg) {
            this.errorMsgClass = '';
        }
    }
}

// export class BlockBaseData {
//     public type: any;
//     public data: any;
//     public args: any;
//     public component: BlockBaseComponent;
// }
